import * as React from 'react';
import styled from '@emotion/styled';
import { COLOR, FONT_WEIGHT, FONT_SIZE } from '@ordermentum/ui-static';
import C from '@ordermentum/ui-constants';

const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 70vh;
`;

const Title = styled('div')`
  color: ${COLOR.GRAY_CHARCOAL};
  font-weight: ${FONT_WEIGHT.BOLD};
  font-size: ${FONT_SIZE.LARGE};
  text-align: center;
  margin-bottom: 1rem;
`;
const Subtitle = styled('div')`
  font-size: ${FONT_SIZE.MEDIUM};
  color: ${COLOR.GRAY};
  text-align: center;
`;
const Logo = styled('div')`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;

  & img {
    height: 5rem;
  }
`;

const Error404 = () => (
  <Wrapper>
    <Logo>
      <img
        alt="Ordermentum"
        src={`${C.IMAGE_URL}/logo-ordermentum-small.svg`}
      />
    </Logo>
    <Title>Page not found</Title>
    <Subtitle>
      {`Sorry, the page you're trying to access could not be found.`}
    </Subtitle>
  </Wrapper>
);

export default Error404;
